import React from 'react'

type Props = React.SVGProps<SVGSVGElement>;

export const ExBasicUserIcon = ({ width = 40, height = 40, ...props }: Props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 300 300"
            {...props}
        >
            <path
                style={{
                    fill: '#2db19a',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M3.518 149.737c-.025 39.23 15.891 78.352 44.178 105.576 27.51 27.585 66.645 43.203 105.583 42.343 38.715.001 77.043-16.489 103.987-44.18 27.196-27.771 43.227-66.654 41.953-105.701.372-39.016-17.109-77.264-44.682-104.355-27.886-26.923-66.454-42.403-105.306-41.467-38.446.347-76.508 16.451-103.282 44.09C18.749 73.21 3.59 111.347 3.518 149.737Zm61.326 81.513h175.39c-.794-12.957-4.289-25.629-9.283-37.568-1.667-4.024-3.872-7.82-5.883-11.667-1.973-3.107-4.189-6.792-6.247-9.567-4.137-5.692-8.651-11.031-14.131-15.649-3.89-3.496-8.068-6.551-12.509-9.307-6.696-4.173-14.038-7.323-21.709-9.152-4.186-.757-8.274-2.294-12.612-2.012-4.536.108-9.088-.141-13.615.1-11.203 1.391-22.056 5.192-31.606 11.225-3.621 2.098-6.803 4.782-10.131 7.161-2.642 2.481-5.52 4.977-8.01 7.671-4.233 4.418-7.883 9.337-11.338 14.519-2.548 3.655-4.682 7.77-6.736 11.788-6.542 13.182-10.302 27.859-11.58 42.458Zm50-120.312c1.361.276 2.301 2.271 3.178 3.001 1.475 1.579 3.016 3.169 4.588 4.8.749.595 1.451 1.226 2.356 1.912.93.645 1.81 1.04 1.987 2.396 2.081.057 3.722 1.565 5.527 2.372.977.503 1.97.992 3.026 1.3.927.296 2.12.492 2.385 1.406 1.804.26 3.608.547 5.395.88 1.46.717 4.248.192 4.761 1.464 2.924-.026 5.873.075 8.781-.15 1.091-.93 3.803-.816 5.525-1.445 1.413-.265 2.869-.342 4.238-.804 1.691-1.101 3.879-1.525 5.816-2.559 1.874-.821 3.571-2.404 5.718-2.464.393-1.344 1.587-2.137 2.881-3.14 1.76-1.244 3.102-2.916 4.653-4.463.406-.326.83-1.042 1.277-1.109.016-.776.903-1.139 1.404-1.911.435-.716.773-1.478 1.894-1.486.526-3.354 3.254-5.992 4.109-9.232 1.34-1.019 1.109-3.989 1.702-5.374.625-1.41.378-4.056 1.611-4.535v-9.375c.019-1.126.009-2.276-.203-3.383-.847-.924-.859-3.413-1.471-4.908-.297-2.981-1.294-4.831-2.473-7.31-1-2.297-3.015-4.698-3.275-7.055l-1.562-.391c-.213-1.386-1.631-2.423-2.341-3.489-.96-1.151-2.615-2.202-2.737-3.542-1.203-.274-2.158-1.342-3.013-2.07-.85-.795-2.191-1.526-2.456-2.618-1.953-.048-3.516-1.396-5.187-2.213-.84-.409-1.778-.971-2.581-1.263-.771-.29-1.796-.352-1.998-1.211-1.661-.275-3.83-.989-5.847-1.174-1.508-.758-4.544-.198-5.09-1.561-2.935.123-5.898-.158-8.826.108-.98.276-1.671.881-2.783.844-3.29.504-7.313 1.233-9.871 2.565-3.126.679-6.041 3.642-8.989 3.905-.222 1.093-1.609 1.791-2.493 2.645-.946.812-1.774 1.751-2.976 2.043-.172 1.545-1.844 2.314-2.69 3.487-.861 1.246-2.132 2.124-2.388 3.544l-1.562.391c-.395 2.877-3.239 5.942-4.104 9.227-1.303.964-1.092 3.811-1.651 5.137-.752 1.519-.448 4.241-1.667 4.776v9.164c-.099 1.136.065 2.253.153 3.374.923 1.283 1.024 3.496 1.487 4.962.319 2.994 1.213 4.915 2.515 7.382 1.094 2.267 2.953 4.811 3.267 7.15Z"
            />
            <path
                style={{
                    fill: '#fff',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M241.016 231.055c-2.225-15.039-5.185-30.219-12.543-43.763-2.388-4.676-4.908-9.187-7.933-13.405a110.924 110.924 0 0 0-8.797-11.05c-5.962-6.066-12.241-11.78-19.663-16.057-22.68-13.516-52.587-14.798-75.907-1.797-4.794 2.534-9.145 5.645-13.335 8.966-3.632 3.196-7.529 6.512-10.748 10.232-2.597 3.568-5.939 6.876-8.278 10.787-2.29 3.47-4.525 6.926-6.378 10.755-3.769 7.243-6.992 14.947-9.027 22.888-2.286 7.138-3.489 14.711-4.149 22.113.455 1.496 3.615.603 4.684.917 56.364-.002 112.717.002 169.078-.002 1.022-.025 2.135.024 2.996-.584ZM183.984 51.953c-2.635-.917-4.259-4.031-7.46-5.137-1.375-.732-2.698-1.567-4.106-2.236-1.121-.893-3.283-.949-3.668-2.002-4.396-.593-8.638-2.037-13.021-2.68-3.412-.369-6.777-.056-10.047.852-4.684.613-9.103 1.494-13.06 3.852-1.945 1.231-4.43 2.314-6.21 3.425-1.774 1.133-3.661 3.423-5.318 3.926-.105 1.488-1.643 2.139-2.455 3.234-.951 1.186-1.423 1.856-2.408 2.856-1.266 1.534-3.062 4.204-4.091 6.552-.871 1.727-1.865 3.927-2.744 5.906-1.029 4.478-2.418 9.678-2.365 13.861.083 2.178-.15 4.774.203 6.75 1.298 3.287 1.488 7.909 2.873 10.746 1.177 2.495 2.874 5.71 4.105 7.999.684 1.178 1.631 2.19 2.414 3.299 1.374 1.684 3.282 3.578 5.053 5.454.778.811 1.425 1.413 2.404 1.902 2.466 2.435 6.672 4.797 10.628 6.467 1.578.309 3.464 1.4 4.701 1.813 5.974.843 12.208 3.479 18.309 1.477 2.847-.817 5.848-.934 8.698-1.684 2.674-1.198 5.502-2.029 8.039-3.551 1.173-.773 2.919-1.519 3.859-2.176 1.016-.743 1.731-1.61 3.012-2.508 1.695-1.193 3.478-3.307 5.254-5.073.455-.316.859-.688 1.078-1.246 2.618-2.995 5.3-7.825 6.843-11.283 1.636-2.887 1.884-6.525 2.779-9.801.962-2.632.812-5.432.764-8.191.356-3.909-.949-8.255-1.804-11.691-.605-3.326-2.396-6.51-4.281-10.19-1.003-2.287-2.471-4.333-3.861-5.728-.621-.567-1.296-1.813-2.159-2.515-.707-.75-1.849-1.391-1.958-2.679Z"
            />
            <path
                style={{
                    fill: '#ace0d7',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M107.031 79.688h.782v-1.172h-.782v1.172Zm90.235 0h.781v-1.172h-.781v1.172Z"
            />
            <path
                style={{
                    fill: '#a8dfd5',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M107.031 92.188h.782v-1.172h-.782v1.172Zm90.235 0h.781v-1.172h-.781v1.172Z"
            />
            <path
                style={{
                    fill: '#40b8a3',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M126.172 122.363c.161.311.432.633.391 1.075h.781v-.782c-.439.012-.795-.211-1.172-.39v.097Zm52.344 1.075c-.054-.385.311-.872.195-1.172a1.358 1.358 0 0 1-.977.39c-.042.529.291.841.782.782Z"
            />
            <path
                style={{
                    fill: '#63c5b4',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M115.234 60.156c-.053-.384.312-.871.196-1.172a1.36 1.36 0 0 1-.977.391c-.042.529.291.841.781.781Zm74.219-1.074c.161.31.433.633.391 1.074h.781v-.781c-.439.012-.795-.211-1.172-.391v.098Z"
            />
            <path
                style={{
                    fill: '#48bba7',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M126.172 48.291c.372.044.723-.26 1.172-.244v-.781h-.781c.075.449-.157.7-.391 1.025Zm52.539.147c.092-.369-.244-.725-.195-1.172h-.782c-.046.723.605.843.977 1.172Z"
            />
            <path
                style={{
                    fill: '#5bc2b0',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M115.234 111.328v-.781h-.781c-.089.562.275.863.781.781Zm75.391 0v-.781h-.781c-.089.562.275.863.781.781Z"
            />
            <path
                style={{
                    fill: '#81d0c2',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M109.766 68.872c.13.277.566.135.781.073-.262-.079-.512-.158-.781-.195v.122Zm84.765 0c.131.277.567.135.782.073-.263-.079-.512-.158-.782-.195v.122Z"
            />
            <path
                style={{
                    fill: '#7dcfc0',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M136.523 43.359c.115-.251.19-.507.196-.781-.346.023-.416.302-.326.579l.13.202Zm32.032 0c.115-.251.189-.507.195-.781-.345.023-.416.302-.326.579l.131.202Z"
            />
            <path
                style={{
                    fill: '#96d8cc',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M148.828 130.859v-.781h-1.172c-.091.649.334.846.863.781h.309Zm8.594 0v-.781h-1.172c-.091.649.334.846.863.781h.309Z"
            />
            <path
                style={{
                    fill: '#7bcec0',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M109.766 101.685c.13.277.566.135.781.073-.262-.079-.512-.159-.781-.195v.122Zm84.765 0c.131.277.567.135.782.073-.263-.079-.512-.159-.782-.195v.122Z"
            />
            <path
                style={{
                    fill: '#8fd5c9',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M147.852 130.859c.115-.251.189-.507.195-.781-.345.023-.416.302-.326.579l.131.202Zm9.375 0c.115-.251.189-.507.195-.781-.345.023-.416.302-.326.579l.131.202Z"
            />
            <path
                style={{
                    fill: '#95d8cc',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M148.438 40.625v-.781h-1.172c-.091.649.333.846.862.781h.31Zm9.375 0v-.781h-1.172c-.091.649.333.846.862.781h.31Z"
            />
            <path
                style={{
                    fill: '#a9dfd6',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M148.242 40.625a1.98 1.98 0 0 0 .196-.781c-.346.022-.416.302-.326.578l.13.203Zm8.594 0c.115-.251.189-.507.195-.781-.345.022-.416.302-.325.578l.13.203Z"
            />
            <path
                style={{
                    fill: '#c9ebe5',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M138.281 128.516v-.782h-.781c-.089.562.275.863.781.782Zm29.297 0v-.782h-.781c-.089.562.275.863.781.782Z"
            />
            <path
                style={{
                    fill: '#a3ddd3',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M148.633 130.859c.115-.251.189-.507.195-.781-.345.023-.416.302-.325.579l.13.202Zm7.812 0c.115-.251.19-.507.196-.781-.346.023-.416.302-.326.579l.13.202Z"
            />
            <path
                style={{
                    fill: '#7ccec0',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M137.695 128.516c.115-.251.19-.507.196-.782-.346.023-.416.302-.326.579l.13.203Zm29.688 0c.115-.251.189-.507.195-.782-.345.023-.416.302-.325.579l.13.203Z"
            />
            <path
                style={{
                    fill: '#8cd4c8',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M147.461 40.625c.115-.251.189-.507.195-.781-.345.022-.416.302-.325.578l.13.203Zm10.156 0a1.98 1.98 0 0 0 .196-.781c-.346.022-.416.302-.326.578l.13.203Z"
            />
            <path
                style={{
                    fill: '#daf1ed',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M147.266 234.106c.13.277.566.136.781.074-.262-.079-.512-.159-.781-.196v.122Zm9.765 0c.131.277.567.136.782.074-.263-.079-.512-.159-.782-.196v.122Z"
            />
            <path
                style={{
                    fill: '#c5eae3',
                    fillRule: 'evenodd',
                    stroke: 'none',
                }}
                d="M147.266 234.155c.133.161.246.117.39.025-.125-.08-.251-.168-.39-.025Zm10.156 0c.134.161.246.117.391.025-.125-.08-.252-.168-.391-.025Z"
            />
        </svg>
    )
}
